import React, { useState, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";

const BlacklistDetail = ({ contacts = [] }) => {
  const params = useParams();
  const location = useLocation();
  const id = params?.id;
  const nome = location?.state?.nome || `Blacklist ${id}`;
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [novoNome, setNovoNome] = useState("");
  const [novoNumero, setNovoNumero] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editingEntry, setEditingEntry] = useState(null);
  const fileInputRef = useRef(null);
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

  const formatPhone = (value) => {
    if (!value) return "";
    const digits = value.replace(/\D/g, "");
    // Brasil: (AA) NNNNN-NNNN or (AA) NNNN-NNNN
    if (digits.length <= 2) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0,2)}) ${digits.slice(2)}`;
    if (digits.length <= 10) return `(${digits.slice(0,2)}) ${digits.slice(2,6)}-${digits.slice(6)}`;
    return `(${digits.slice(0,2)}) ${digits.slice(2,7)}-${digits.slice(7,11)}`;
  };

  const openEdit = (entry) => {
    setEditingEntry(entry);
    setNovoNome(entry.nome || "");
    setNovoNumero(formatPhone(entry.numero || ""));
    setEditModalOpen(true);
    setOpenMenuId(null);
  };

  const handleDelete = (entry) => {
    // dispatch delete event
    window.dispatchEvent(new CustomEvent('blacklist:delete', { detail: { id: entry.id, listId: entry.listId } }));
    setOpenMenuId(null);
  };

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{
        width: '100%',
        maxWidth: 820,
        background: 'linear-gradient(180deg, #ffffff, #fbfdff)',
        borderRadius: 14,
        boxShadow: '0 12px 30px rgba(10,15,25,0.08)',
        padding: 24,
        border: '1px solid rgba(0,0,0,0.04)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <div style={{
            width: 56,
            height: 56,
            borderRadius: 10,
            background: '#ffebee',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#c0392b',
            fontSize: 26,
            flex: '0 0 56px'
          }}>
            <i className="bi bi-person-x" />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <div style={{ fontSize: 22, fontWeight: 700, color: '#0f1720' }}>{nome}</div>
            <div style={{ fontSize: 13, color: '#6b7280', marginTop: 4 }}>Lista de bloqueio</div>
          </div>
        </div>

        <div style={{ marginTop: 18, display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          <input
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Pesquisar nesta blacklist"
            style={{
              flex: 1,
              padding: '10px 12px',
              borderRadius: 8,
              border: '1px solid rgba(0,0,0,0.06)',
              fontSize: 14,
            }}
          />

          <button
            className="btn"
            onClick={() => setModalOpen(true)}
            style={{
              padding: '10px 14px',
              borderRadius: 8,
              background: '#005c53',
              color: '#fff',
              border: 'none',
              fontWeight: 600,
              flex: '0 0 auto',
              marginTop: isMobile ? 8 : 0,
            }}
          >
            Adicionar
          </button>

          <input ref={fileInputRef} type="file" accept=".csv,text/csv" style={{ display: 'none' }} onChange={(e) => {
            const file = e.target.files && e.target.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = (evt) => {
              try {
                const text = evt.target.result;
                const rows = text.split(/\r?\n/).map(r => r.trim()).filter(r => r.length);
                let added = 0;
                rows.forEach((row, idx) => {
                  // split on commas not inside quotes
                  const cols = row.split(/,(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/).map(c => c.replace(/^\"|\"$/g, '').trim());
                  const nomeCol = cols[0] || '';
                  const numeroCol = cols[1] || '';
                  const raw = (numeroCol || nomeCol).replace(/\D/g, '');
                  if (!raw) return;
                  const entry = { id: Date.now() + idx, nome: nomeCol || raw, numero: raw, listId: id, createdAt: new Date().toISOString() };
                  window.dispatchEvent(new CustomEvent('blacklist:add', { detail: entry }));
                  added += 1;
                });
                if (added > 0) alert(`${added} contatos importados com sucesso.`);
              } catch (err) {
                console.error('Erro ao ler CSV', err);
                alert('Erro ao processar o arquivo CSV. Verifique o formato.');
              }
            };
            reader.readAsText(file, 'UTF-8');
            // reset so same file can be selected again
            e.target.value = '';
          }} />
          <button
            className="btn"
            onClick={() => fileInputRef.current && fileInputRef.current.click()}
            style={{
              padding: '10px 14px',
              borderRadius: 8,
              border: '1px solid rgba(0,0,0,0.06)',
              background: '#fff',
              color: '#111827',
              flex: '0 0 auto',
              marginTop: isMobile ? 8 : 0,
              minWidth: 110,
            }}
          >
            Adicionar CSV
          </button>
        </div>
        {modalOpen && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.35)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{ background: '#fff', borderRadius: 12, padding: 24, minWidth: 360, boxShadow: '0 8px 40px rgba(0,0,0,0.18)' }}>
              <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 12, color: '#005c53' }}>Adicionar contato à blacklist</div>
              <input
                type="text"
                placeholder="Nome"
                value={novoNome}
                onChange={e => setNovoNome(e.target.value)}
                style={{ width: '100%', padding: 10, fontSize: 14, border: '1px solid #ddd', borderRadius: 8, marginBottom: 10 }}
              />
              <input
                type="text"
                inputMode="numeric"
                placeholder="Número (somente dígitos)"
                value={novoNumero}
                onChange={e => setNovoNumero(formatPhone(e.target.value))}
                style={{ width: '100%', padding: 10, fontSize: 14, border: '1px solid #ddd', borderRadius: 8, marginBottom: 14 }}
              />
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                <button onClick={() => { setModalOpen(false); setNovoNome(''); setNovoNumero(''); }} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#eee' }}>Cancelar</button>
                <button
                  onClick={() => {
                    const entry = { id: Date.now(), nome: novoNome.trim(), numero: novoNumero.trim() };
                    if (novoNome.trim() && novoNumero.trim()) {
                      const rawNumber = novoNumero.replace(/\D/g, '');
                      const entryToSend = { ...entry, numero: rawNumber, listId: id, createdAt: new Date().toISOString() };
                      // dispara evento custom para que o index.js atualize a lista
                        window.dispatchEvent(new CustomEvent('blacklist:add', { detail: entryToSend }));
                      setModalOpen(false);
                      setNovoNome('');
                      setNovoNumero('');
                    }
                  }}
                  style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#005c53', color: '#fff', fontWeight: 700 }}
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        )}
        {editModalOpen && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.35)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <div style={{ background: '#fff', borderRadius: 12, padding: 24, minWidth: 360, boxShadow: '0 8px 40px rgba(0,0,0,0.18)' }}>
              <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 12, color: '#005c53' }}>Editar contato</div>
              <input
                type="text"
                placeholder="Nome"
                value={novoNome}
                onChange={e => setNovoNome(e.target.value)}
                style={{ width: '100%', padding: 10, fontSize: 14, border: '1px solid #ddd', borderRadius: 8, marginBottom: 10 }}
              />
              <input
                type="text"
                inputMode="numeric"
                placeholder="Número (somente dígitos)"
                value={novoNumero}
                onChange={e => setNovoNumero(formatPhone(e.target.value))}
                style={{ width: '100%', padding: 10, fontSize: 14, border: '1px solid #ddd', borderRadius: 8, marginBottom: 14 }}
              />
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                <button onClick={() => { setEditModalOpen(false); setEditingEntry(null); setNovoNome(''); setNovoNumero(''); }} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#eee' }}>Cancelar</button>
                <button
                  onClick={() => {
                    if (!editingEntry) return;
                    const rawNumber = novoNumero.replace(/\D/g, '');
                    const updated = { ...editingEntry, nome: novoNome.trim(), numero: rawNumber };
                    window.dispatchEvent(new CustomEvent('blacklist:edit', { detail: updated }));
                    setEditModalOpen(false);
                    setEditingEntry(null);
                    setNovoNome('');
                    setNovoNumero('');
                  }}
                  style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#005c53', color: '#fff', fontWeight: 700 }}
                >
                  Salvar
                </button>
              </div>
            </div>
          </div>
        )}
        {/* tabela de contatos desta blacklist */}
        {contacts && contacts.length > 0 && (
          <div style={{ marginTop: 20, maxHeight: 300, overflowY: 'auto', overflowX: 'auto', borderRadius: 8, border: '1px solid rgba(0,0,0,0.04)' }}>
            <table className="table" style={{ margin: 0 }}>
              <thead style={{ background: '#f8fafc', position: 'sticky', top: 0 }}>
                <tr>
                  <th style={{ padding: '10px 12px' }}>Nome</th>
                  <th style={{ padding: '10px 12px' }}>Número</th>
                  <th style={{ padding: '10px 12px' }}>Data</th>
                  <th style={{ padding: '10px 12px', width: 60 }}></th>
                </tr>
              </thead>
              <tbody>
                {contacts.map(c => (
                  <>
                    <tr key={c.id}>
                      <td style={{ padding: '10px 12px', minWidth: 120 }}>{c.nome}</td>
                      <td style={{ padding: '10px 12px' }}>{(c.numero || '').replace(/(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3')}</td>
                      <td style={{ padding: '10px 12px' }}>{new Date(c.createdAt).toLocaleString()}</td>
                      <td style={{ padding: '10px 12px', width: 60 }}>
                        <div>
                          <button onClick={() => setOpenMenuId(openMenuId === c.id ? null : c.id)} className="btn btn-sm" style={{ padding: '6px 8px', border: 'none', background: 'transparent' }}>⋯</button>
                        </div>
                      </td>
                    </tr>
                    {openMenuId === c.id && (
                      <tr key={`${c.id}-menu`}>
                        <td colSpan={4} style={{ padding: '8px 12px', background: '#fff' }}>
                          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                            <button onClick={() => openEdit(c)} className="btn btn-sm" style={{ padding: '6px 10px' }}>Editar</button>
                            <button onClick={() => handleDelete(c)} className="btn btn-sm btn-danger" style={{ padding: '6px 10px' }}>Excluir</button>
                          </div>
                        </td>
                      </tr>
                    )}
                  </>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlacklistDetail;
